export const isFunction = (fn) => fn instanceof Function;
